var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddHardware = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "31px",
    viewBox: "0 0 52 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-at-a-Glance",
    transform: "translate(-162.000000, -344.000000)",
    fill: "#FFD110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(162.000000, 344.916667)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "8.83138021 0 43.4956868 0 51.0416667 21.6666667 0 21.6666667"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.15318627,
    y1: 11.3541667,
    x2: 46.6237745,
    y2: 11.3541667,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.44485294,
    y1: 5.3125,
    x2: 44.5036765,
    y2: 5.3125,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.9375,
    y1: 0.778186275,
    x2: 18.0674784,
    y2: 20.8683378,
    id: "Line-3",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.1875,
    y1: 0.569852941,
    x2: 35.3653867,
    y2: 21.506518,
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9166667,21.6666667 L27.9163333,26.4576667 L34.5833333,26.4583333 L34.5833333,29.5833333 L17.7083333,29.5833333 L17.7083333,26.4583333 L24.3743333,26.4576667 L24.375,21.6666667 L27.9166667,21.6666667 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddHardware);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-hardware.8e947ad8288ffb97d8a1d48657d0a495.svg";